import type { ScheduleAction } from './types';

export function scheduleActionStatusLabel(row: ScheduleAction): string {
  const now = Date.now();
  const execAt = new Date(row.schedule_execution).getTime();

  if (row.status === 3) return 'Отмена. Достигнута цель';
  if (row.status === 1) return 'Выполняется';
  if (row.status === 2) {
    return row.success ? 'Выполнено' : 'Ошибка';
  }
  if (row.status === 0) {
    return execAt > now ? 'Отложено' : 'В очереди';
  }
  return `Статус ${row.status}`;
}
